/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import { ROOT_URL_V2, getCSRFToken } from '../../../../config';

import Tooltip from '../../../common/Tooltip';

const propTypes = {
    job: PropTypes.object,
    jobs: PropTypes.array,
    isBulkExclusiveMode: PropTypes.bool,
    notification: PropTypes.object.isRequired,
    onFeedbackPostSuccess: PropTypes.func.isRequired,
    totalNumberOfJobsInTable: PropTypes.number,
};

const rules = [
    {
        clientScore: 5,
        questionText: 'What made them stand out?',
        tags: [
            { value: 'communication_skills', label: 'Great communication' },
            { value: 'speed', label: 'Fast worker' },
            { value: 'attitude', label: 'Good attitude' },
            { value: 'skills', label: 'Highly skilled' },
            { value: 'time_management', label: 'Punctuality' },
        ],
        starsByCountOfTappedTags: {
            1: 5,
            2: 5,
            3: 5,
            4: 5,
            5: 5,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 4,
        questionText: 'How could they reach 5 stars?',
        tags: [
            { value: 'communication_skills', label: 'Communication' },
            { value: 'speed', label: 'Work faster' },
            { value: 'attitude', label: 'Better attitude' },
            { value: 'skills', label: 'Improve skills' },
            { value: 'time_management', label: 'Be more punctual' },
        ],
        starsByCountOfTappedTags: {
            1: 2,
            2: 3,
            3: 3,
            4: 4,
            5: 4,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 3,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 2,
            3: 2,
            4: 3,
            5: 3,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 2,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 1,
            3: 1,
            4: 2,
            5: 2,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 1,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late or no show' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 1,
            3: 1,
            4: 1,
            5: 1,
        },
        isJobOfferTag: false,
    },
];

class BookingDetailsFeedback extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rating: 0,
            tagsSelected: [],
            comment: '',
            isJobOffer: false,
            isPostingFeedback: false,
        };

        this.handleStarClick = this.handleStarClick.bind(this);
        this.onTagClick = this.onTagClick.bind(this);
    }

    postFeedback() {
        const clientScore = this.state.rating;
        const {
            job,
            jobs,
            isBulkExclusiveMode,
            notification,
            onFeedbackPostSuccess,
            totalNumberOfJobsInTable,
        } = this.props;
        if (job) {
            const jobId = this.props.relevantJobId;
            const freelancerId = this.props.job.booking.freelancer_detail.id;

            const data = {
                freelancer: freelancerId,
                score: clientScore,
                job_offer: this.state.isJobOffer,
                comment: this.state.comment,
            };

            const { tagsSelected } = this.state;
            if (tagsSelected.length > 0) {
                const rule = rules.find(
                    item => item.clientScore === clientScore,
                );
                const tagScore =
                    rule.starsByCountOfTappedTags[tagsSelected.length];
                tagsSelected.map(tag => {
                    data[tag] = tagScore;
                });
            }

            this.setState({
                isPostingFeedback: true,
            });

            axios({
                method: 'POST',
                url: `${ROOT_URL_V2}jobs/${jobId}/feedbacks/`,
                data,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            })
                .then(() => {
                    this.setState({
                        isPostingFeedback: false,
                    });
                    notification.success(
                        'Success',
                        'The booking have been successfully reviewed',
                    );
                    onFeedbackPostSuccess();
                })
                .catch(error => {
                    this.setState({
                        isPostingFeedback: false,
                    });
                    const errorMsg =
                        error &&
                        error.response &&
                        error.response.data.meta.detail.non_field_errors
                            ? error.response.data.meta.detail.non_field_errors.join(
                                  ', ',
                              )
                            : error && error.response
                            ? JSON.stringify(error.response.data.meta.detail)
                            : 'Failed to review the booking';
                    notification.error('Error', errorMsg);
                    throw error;
                });
            return;
        }

        if (jobs) {
            const ids = jobs.map(job => job.booking.id);
            const countOfSelected = isBulkExclusiveMode
                ? totalNumberOfJobsInTable - jobs.length
                : jobs.length;

            const data = {
                score: clientScore,
                job_offer: this.state.isJobOffer,
            };
            if (isBulkExclusiveMode) {
                data.excluded_bookings = ids;
            } else {
                data.bookings = ids;
            }

            const { tagsSelected } = this.state;
            if (tagsSelected.length > 0) {
                const rule = rules.find(
                    item => item.clientScore === clientScore,
                );
                const tagScore =
                    rule.starsByCountOfTappedTags[tagsSelected.length];
                tagsSelected.map(tag => {
                    data[tag] = tagScore;
                });
            }

            const filter = this.props.location.search;

            this.setState({
                isPostingFeedback: true,
            });

            axios({
                method: 'POST',
                url: `${ROOT_URL_V2}jobs/feedbacks/${
                    isBulkExclusiveMode ? filter : ''
                }`,
                data,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            })
                .then(() => {
                    this.setState({
                        isPostingFeedback: false,
                    });
                    notification.success(
                        'Success',
                        `${countOfSelected} bookings have been successfully reviewed`,
                    );
                    onFeedbackPostSuccess();
                })
                .catch(error => {
                    this.setState({
                        isPostingFeedback: false,
                    });
                    notification.error(
                        'Error',
                        `Failed to review ${countOfSelected} bookings.
                        Try to select less bookings.`,
                    );
                    throw error;
                });
        }
    }

    handleStarClick(index) {
        this.setState({
            rating: index,
            tagsSelected: [],
            isJobOffer: false,
        });
    }

    renderTitle() {
        const { rating } = this.state;
        if (rating === 0) {
            return (
                <div className="booking-details-feedback__title">
                    Rate the worker
                </div>
            );
        }

        return null;
    }

    renderStars() {
        const { rating } = this.state;
        const stars = [];
        for (let i = 0; i <= 4; i++) {
            const classNames = [
                'icon icon-star-full',
                i < rating ? 'active' : '',
            ];
            const star = (
                <i
                    key={i}
                    className={classNames.join(' ')}
                    onClick={() => {
                        this.handleStarClick(i + 1);
                    }}
                />
            );
            stars.push(star);
        }
        return <div className="booking-details-feedback__stars">{stars}</div>;
    }

    renderTags() {
        const { rating, tagsSelected } = this.state;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);
            const { tags } = rule;

            return tags.map((tag, index) => {
                const isSelected = tagsSelected.indexOf(tag.value) >= 0;
                return (
                    <div
                        key={index}
                        className={[
                            'booking-details-feedback__tag',
                            isSelected ? 'active' : '',
                        ].join(' ')}
                        onClick={() => {
                            this.onTagClick(tag.value);
                        }}
                    >
                        {tag.label}
                    </div>
                );
            });
        }

        return null;
    }

    renderExistingTags() {
        const { client_feedback } = this.props.job.booking;
        const rule = rules.find(
            item => item.clientScore === client_feedback.score,
        );
        const { tags } = rule;
        const workerTags = Object.keys(client_feedback).reduce((prev, curr) => {
            tags.forEach(tag => {
                if (tag.value == curr && client_feedback[curr]) {
                    prev.push(tag.label);
                }
            });
            return prev;
        }, []);

        return workerTags.map((tag, index) => (
            <div
                key={index}
                className={['booking-details-feedback__tag', 'active'].join(
                    ' ',
                )}
            >
                {tag}
            </div>
        ));
    }

    renderQuestion() {
        const { rating } = this.state;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);
            const { questionText } = rule;

            return (
                <div className="booking-details-feedback__question">
                    {questionText}
                </div>
            );
        }

        return null;
    }

    renderJobOfferTag() {
        const { rating, isJobOffer } = this.state;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);

            if (rule.isJobOfferTag) {
                return (
                    <div
                        className={[
                            'booking-details-feedback__tag separated checkbox',
                            isJobOffer ? 'active' : '',
                        ].join(' ')}
                        onClick={() => {
                            this.setState({ isJobOffer: !isJobOffer });
                        }}
                    >
                        I would like to work with this buzzworker regularly
                    </div>
                );
            }

            return null;
        }

        return null;
    }

    onTagClick(value) {
        const { tagsSelected } = this.state;
        const index = tagsSelected.indexOf(value);
        if (index >= 0) {
            tagsSelected.splice(index, 1);
        } else {
            tagsSelected.push(value);
        }
        this.setState({
            tagsSelected,
        });
    }

    renderExistingFeedback() {
        const { client_feedback } = this.props.job.booking;
        if (client_feedback) {
            const stars = [];
            const rating = client_feedback.score;
            const dateCreated = moment(client_feedback.created).format(
                'DD/MM/YYYY',
            );
            for (let i = 0; i <= 4; i++) {
                const classNames = [
                    'icon icon-star-full',
                    i < rating ? 'active' : '',
                ];
                const star = <i key={i} className={classNames.join(' ')} />;
                stars.push(star);
            }
            return (
                <Tooltip tooltip={`Review given on ${dateCreated}`}>
                    <div className="booking-details-feedback">
                        <div className="booking-details-feedback__static-stars">
                            {stars}
                        </div>
                        {client_feedback.comment ? (
                            <p className="booking-details-feedback__feedback">
                                {`"${client_feedback.comment}"`}
                            </p>
                        ) : null}
                        <div className="booking-details-feedback__tags">
                            {this.renderExistingTags()}
                        </div>
                    </div>
                </Tooltip>
            );
        }
    }

    renderFeedbackForm() {
        const { rating, isPostingFeedback } = this.state;

        return (
            <div className="booking-details-feedback">
                {this.renderStars()}
                {this.renderTitle()}
                {this.renderQuestion()}
                <div className="booking-details-feedback__tags">
                    {this.renderTags()}
                </div>
                {this.renderJobOfferTag()}

                {rating > 0 ? this.commentForm() : null}
                {rating > 0 ? (
                    <button
                        className="btn--round-small"
                        onClick={this.postFeedback.bind(this)}
                        disabled={isPostingFeedback}
                    >
                        {isPostingFeedback ? 'Saving...' : 'Save'}
                    </button>
                ) : null}
            </div>
        );
    }

    commentForm() {
        const { comment } = this.state;
        return (
            <div className="booking-details-feedback">
                <p className="booking-details-feedback__question">
                    Any additional comments?
                </p>
                <textarea
                    className="booking-details-feedback__comment"
                    onChange={this.handleComment}
                    value={comment}
                />
            </div>
        );
    }

    handleComment = e => {
        this.setState({ comment: e.target.value });
    };

    render() {
        const client_feedback = this.props.job
            ? this.props.job.booking.client_feedback
            : null;
        if (client_feedback) {
            return this.renderExistingFeedback();
        }
        return this.renderFeedbackForm();
    }
}

BookingDetailsFeedback.propTypes = propTypes;

export default withRouter(BookingDetailsFeedback);
